import { forwardRef } from 'react'
import styles from './Button.module.css'

const isExternal = (href) => /^https?:\/\//.test(href)

const Button = forwardRef(
  (
    { as, href, variant = 'primary', size = 'md', type, className = '', children, ...props },
    ref
  ) => {
    const Component = as || (href ? 'a' : 'button')

    const classes = [styles.button, styles[variant], styles[size], className]
      .filter(Boolean)
      .join(' ')

    const linkProps =
      Component === 'a' && isExternal(href)
        ? { target: '_blank', rel: 'noopener noreferrer' }
        : {}

    const buttonProps = Component === 'button' ? { type: type || 'button' } : {}

    return (
      <Component
        ref={ref}
        className={classes}
        href={href}
        {...linkProps}
        {...buttonProps}
        {...props}
      >
        {children}
      </Component>
    )
  }
)

Button.displayName = 'Button'

export default Button
